module.exports = __webpack_public_path__ + "static/media/lake-bled.32ca012a.jpg";